import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router";

import { useAppSelector, useResetState } from "@redux/hooks";
import { selectPolicyDetails } from "@redux/slices";
import { StepPath } from "@routing/paths";

/**
 * Reset redux state and navigate to initial step of the flow.
 *
 */
export const useResetFlowWhenNoData = () => {
  const resetState = useResetState();
  const navigate = useNavigate();

  const { pathname } = useLocation();
  const { dateOfLoss } = useAppSelector(selectPolicyDetails);

  useEffect(() => {
    if (!dateOfLoss && pathname !== `/${StepPath.POLICY_DETAILS}`) {
      resetState();
      navigate(`/${StepPath.POLICY_DETAILS}`);
    }
  }, [pathname, resetState, navigate, dateOfLoss]);
};
